import Vue from 'vue'

const requireComponent = require.context('.', true, /[\w-]+\.vue$/)

requireComponent.keys().forEach(fileName => {
  // Get the component config
  const componentConfig = requireComponent(fileName)

  // Globally register the component
  Vue.component(
    componentConfig.default.extendOptions.name,
    componentConfig.default || componentConfig,
  )
})
